<template>
    <div v-if="text" class="maintenance-message">
        <span class="icon">{{ icon }}</span> <span>{{ text }}</span>
    </div>
</template>

<script setup lang="ts">
defineProps<{
  text?: string,
  icon?: string
}>()
</script>

<style scoped lang="scss">
span {
    display: inline;
    padding: 5px;
}

.maintenance-message {
    background-color: $color-primary;
    color: #FFF;
    font-size: 16px;
    padding: 5px;
    text-align: center;
    width: 100%;
    z-index: 1000;
}

.icon {
    font-size: 20px;
}
</style>
